var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Drawer',{attrs:{"title":_vm.andamento.titulo,"placement":"right","width":"850","before-close":_vm.closeDrawerTicket,"value":_vm.value},on:{"input":v => _vm.$emit('input', v)}},[(_vm.value)?_c('PgdFormCausas',{ref:"form",attrs:{"andamento":_vm.andamento},on:{"input":_vm.emitForm}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }